import styled from 'styled-components';

export const DoohInventoryHeaderStyled = styled.div`
  background: ${props => props.theme.uiColors.sidebarColor};
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  
  .doohInventory__header {
    width: 100%;

    &Logo {
      cursor: pointer;
      flex-shrink: 0;
    }
    &Title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      color: ${props => props.theme.uiColors.textTitle};
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeM};

      &--strong {
        font-family: ${props => props.theme.fontBold};
      }
    }
    
    &Tooltip {
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      align-items: flex-start;
      padding: 8px 16px;

      &Button {
        padding: 0;
      }
    }

    &Button {
      align-items: center;
      column-gap: 8px;
      display: flex;
      text-decoration: none;
    }
  }
`;
